import React, { memo, useContext } from 'react';
import { ScrollLink } from '@prisjakt/ui-scroll';
import { Link, useLocation } from 'react-router-dom';
import { AppContext } from '@prisjakt/ui-app-context';
import { getScrollLinkOffset } from '../../../../utils';
import { StatisticsTabId } from '../../../product-tabs/constants';
import { PriceHistoryLinkWrapper } from './styles';

type OwnProps = {
  className?: string;
  children?: React.ReactElement | null;
  routeSection?: string;
  product: any;
  onClick: () => void;
  shouldRenderAllTabs: boolean;
};

const LinkToPriceHistory = ({
  className,
  children,
  routeSection,
  product,
  onClick,
  shouldRenderAllTabs,
}: OwnProps) => {
  const { linkTo, t } = useContext(AppContext);
  const location = useLocation();
  const to = shouldRenderAllTabs
    ? `${location.pathname}${location.search}${StatisticsTabId}`
    : linkTo('productPriceHistory', product);

  return (
    <PriceHistoryLinkWrapper>
      {routeSection === 'statistics' ? (
        <ScrollLink
          to="Product Information"
          calculateOffset={getScrollLinkOffset}
          onClick={onClick}
          className={className}
        >
          {children}
        </ScrollLink>
      ) : (
        <Link
          to={to}
          onClick={onClick}
          aria-label={t('product', 'tabs.price-history')}
          className={className}
        >
          {children}
        </Link>
      )}
    </PriceHistoryLinkWrapper>
  );
};

export default memo(LinkToPriceHistory);
